import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBoosterParams} from "../../types/booster_generic/IPromotionBooster";

export const findPromotionByType = (promotions?: IPromotionBoosterParams["promotions"], promotionType?: PromotionType) => {
    return (promotions && promotions.find((promotion) => promotion.type === promotionType)) || null;
};
import {PromotionType} from "../../../promotion/helpers/PromotionType";
import {IPromotionBoosterParams} from "../../types/booster_generic/IPromotionBooster";

export const findPromotionByType = (promotions?: IPromotionBoosterParams["promotions"], promotionType?: PromotionType) => {
    return (promotions && promotions.find((promotion) => promotion.type === promotionType)) || null;
};
